import { OrderItem } from '@/data/types/Order';

const getTime = (item: OrderItem) =>
	new Date(item.lastUpdateDate || item.createDate || 0).getTime();

/**
 * Returns the child (SKU/variant) partNumber of the most recently added
 * order item, e.g. "001038706-0114". Items are ranked by `lastUpdateDate`
 * desc, falling back to `createDate` when the update timestamp is missing.
 */
export const getLastAddedChildPartNumber = (
	orderItems: OrderItem[] | undefined
): string | undefined => {
	if (!orderItems?.length) return undefined;

	const latest = [...orderItems].sort((a, b) => getTime(b) - getTime(a))[0];

	return latest?.partNumber.split('-T')[0] || undefined;
};
